import { isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { DateFormatConstants } from '@uzurv/rideWss/app/constants';
import { AbstractModel } from './abstract-model';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import moment from 'moment-timezone';
import { OrganizationInfo } from './organization-info';

@inheritSerialization(AbstractModel)
export class RiderEligibilityProofResponse extends AbstractModel {
  @autoserialize
  partnerIdentifier: string;

  @autoserialize
  firstName: string;

  @autoserialize
  lastName: string;

  @autoserializeAs(Date)
  dateOfBirth: Date;

  @autoserialize
  phoneNumber: string;

  @autoserializeAs(OrganizationInfo)
  organizationInfos: Array<OrganizationInfo>;

  static OnSerialized(instance: RiderEligibilityProofResponse, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.dateOfBirth)) {
      json.dateOfBirth = moment.utc(instance.dateOfBirth).format(DateFormatConstants.ISO_LOCAL_DATE);
    }
  }

  static OnDeserialized(instance: RiderEligibilityProofResponse, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['dateOfBirth'])) {
      instance.dateOfBirth = moment(json['dateOfBirth']).toDate();
    }
  }
}
